'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Delete$() {
}
export { $c_Lpresto_crud$Delete$ as $c_Lpresto_crud$Delete$ };
$p = $c_Lpresto_crud$Delete$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Delete$;
/** @constructor */
function $h_Lpresto_crud$Delete$() {
}
export { $h_Lpresto_crud$Delete$ as $h_Lpresto_crud$Delete$ };
$h_Lpresto_crud$Delete$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2043376075;
});
$p.l = (function() {
  return "Delete";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Delete";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$Delete$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Delete$, "presto.crud$Delete$", ({
  Vl: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$Delete$ as $d_Lpresto_crud$Delete$ };
var $n_Lpresto_crud$Delete$;
function $m_Lpresto_crud$Delete$() {
  if ((!$n_Lpresto_crud$Delete$)) {
    $n_Lpresto_crud$Delete$ = new $c_Lpresto_crud$Delete$();
  }
  return $n_Lpresto_crud$Delete$;
}
export { $m_Lpresto_crud$Delete$ as $m_Lpresto_crud$Delete$ };
//# sourceMappingURL=presto.crud$-Delete$.js.map
